import * as angular from 'angular';
import * as dayjs from 'dayjs';

/* @ngInject */
export function greaterThanDirective ($parse) {
	return {
		restrict: 'A',
		require: 'ngModel',
		link: function link (scope, _elem, attrs, ngModelCtrl) {

			// Watch changes to passed property, cuz we need to re-run our validator when it changes
			const watcher = scope.$watch(function () {
				return $parse(attrs.greaterThan)(scope);
			}, function (newVal, oldVal) {
				if (newVal !== oldVal) {
					ngModelCtrl.$validate();
				}
			});

			ngModelCtrl.$validators.greaterThan = function (modelVal) {
				const compareVal = $parse(attrs.greaterThan)(scope);

				// We can't compare them and enforce if they arent both dates
				if (!angular.isDate(modelVal) || !angular.isDate(compareVal)) {
					return true;
				}

				return dayjs(modelVal).isBefore(compareVal);
			};

			// un-register watcher
			scope.$on('$destroy', watcher);
		}
	};
}
